var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yujianfenzhen"},[(_vm.showForm)?_c('div',{staticClass:"page",class:_vm.isLogin ? 'no-roll' : ''},[_c('YujianfenzhenForm')],1):_c('YujianfenzhenItem',{attrs:{"list":_vm.listData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }